export default __webpack_public_path__ + "static/media/Privacy-Locked.d00d6be5.svg";